// ABOUTME: Index route for /library/$documentId.
// ABOUTME: Renders the DocumentDetail component (PDF viewer).

import DocumentDetail from "@/components/DocumentDetail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/library/$documentId/")({
  component: DocumentDetail,
});
